'use client';

import { useMemo, useReducer } from 'react';
import { useWizardSessionLifecycle } from '../hooks/useWizardSessionLifecycle';
import { initialWizardState, WizardContext } from './WizardContext';
import { wizardReducer } from './wizardReducer';

interface WizardProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component for wizard state management.
 *
 * Features:
 * - useReducer for state management
 * - API persistence to Marketing API
 * - Session ID stored in localStorage for resumability
 * - Hydration-safe initialization
 */
export function WizardProvider({ children }: WizardProviderProps) {
  const [state, dispatch] = useReducer(wizardReducer, initialWizardState);

  useWizardSessionLifecycle(state, dispatch);

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state]
  );

  return (
    <WizardContext.Provider value={contextValue}>
      {children}
    </WizardContext.Provider>
  );
}
